.container {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.labelContainer {
    display: flex;
    gap: 10px;
}

.feedbackContainer {
    background-color: var(--hps-light-gray);
    border-left: 3px solid var(--hps-light-blue);
    border-radius: 6px;
    margin-top: 8px;
    padding: 10px 12px;
}

.feedbackHeader {
    align-items: center;
    display: flex;
    justify-content: space-between;
}
